/**
 * Fitnesspilot
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/**
 * Check if a given object implements the MuscleShare interface.
 */
export function instanceOfMuscleShare(value) {
    let isInstance = true;
    isInstance = isInstance && "muscleId" in value;
    isInstance = isInstance && "intensity" in value;
    return isInstance;
}
export function MuscleShareFromJSON(json) {
    return MuscleShareFromJSONTyped(json, false);
}
export function MuscleShareFromJSONTyped(json, ignoreDiscriminator) {
    if (json === undefined || json === null) {
        return json;
    }
    return {
        muscleId: json.muscleId,
        intensity: json.intensity,
    };
}
export function MuscleShareToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        muscleId: value.muscleId,
        intensity: value.intensity,
    };
}
